// Europe Lease Authorization uses a single named approver (the Portfolio Manager
// selected on the form) rather than the fund-threshold-based approver matrix used by
// LeaseAuthSection/CapitalAuthSection. PortfolioManagerField already seeds
// authorizationData.selectedApprovers directly, so no approver-matrix fetch is needed here.
// This component intentionally renders nothing - it exists only to satisfy the
// Authorization.tsx `parentComp` map contract (same no-render shape as LeaseAuthSection).
const EuropeLeaseAuthSection = (_props: any) => {
    return null;
};

export default EuropeLeaseAuthSection;
